import { collection, addDoc, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from './firebase';
import type { AuditLog } from '@/types';

const AUDIT_LOGS_COLLECTION = 'auditLogs';

// Create audit log entry
export const createAuditLog = async (
  actorUid: string,
  action: AuditLog['action'],
  targetId?: string,
  targetType?: AuditLog['targetType'],
  diff?: Record<string, unknown>,
  metadata?: Record<string, unknown>
): Promise<string> => {
  const auditLog: Omit<AuditLog, 'id'> = {
    actorUid,
    action,
    at: new Date().toISOString(),
    ...(targetId ? { targetId } : {}),
    ...(targetType ? { targetType } : {}),
    ...(diff ? { diff } : {}),
    ...(metadata ? { metadata } : {}),
  };

  const docRef = await addDoc(collection(db, AUDIT_LOGS_COLLECTION), auditLog);
  return docRef.id;
};

// Get audit logs (admin only)
export const getAuditLogs = async (
  limitCount: number = 100
): Promise<AuditLog[]> => {
  const q = query(
    collection(db, AUDIT_LOGS_COLLECTION),
    orderBy('at', 'desc'),
    limit(limitCount)
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  })) as AuditLog[];
};

